export const PL = 'pl-PL'
export const EN = 'en-US'
